<template>
  <svg :viewBox="viewbox" class="icon" :style="iconStyle" :preserveAspectRatio="alignment">
    <component :is="selectedIcon" :settings="settingsProp" @setsize="setViewboxSize($event)" />
  </svg>
</template>

<script>
const requireContext = require.context("./", false, /Icon(?!Base).*\.vue$/);

const iconsObject = requireContext
  .keys()
  .map(file => [file.replace(/(^.\/Icon)|(\.vue$)/g, ""), requireContext(file)])
  .reduce((components, [name, component]) => {
    components[name] = component.default || component;
    return components;
  }, {});

export default {
  name: "IconBase",
  data() {
    return {
      viewbox: ""
    };
  },
  props: {
    name: {
      type: String
    },
    size: {
      type: String,
      default: "1em"
    },
    settings: {
      default: () => {
        return { active: false };
      },
      type: Object
    },
    offsetx: {
      default: "0",
      type: String
    },
    offsety: {
      default: "0",
      type: String
    },
    sizeWidth: {
      default: null,
      type: String
    },
    sizeHeight: {
      default: null,
      type: String
    },
    align: {
      default: "center",
      type: String
    }
  },
  components: {},
  methods: {
    setViewboxSize(size) {
      this.viewbox =
        this.offsetx + " " + this.offsety + " " + size + " " + size;
    }
  },
  computed: {
    selectedIcon: function() {
      return iconsObject[this.name];
    },
    iconStyle: function() {
      return {
        width: this.sizeWidth || this.size,
        height: this.sizeHeight || this.size
      };
    },
    settingsProp: function() {
      return this.settings;
    },
    alignment() {
      let alignment;
      switch (this.align) {
        case "top":
          alignment = "xMidYMin meet";
          break;
        case "bottom":
          alignment = "xMidYMax meet";
          break;
        default:
          alignment = "xMidYMid meet";
      }
      return alignment;
    }
  },
  created() {
    this.viewbox = this.offsetx + " " + this.offsety + " 24 24";
  },
  mounted() {}
};
</script>

<style scoped>
.icon {
  display: inline-block;
  text-align: center;
  fill: currentColor;
  stroke: currentColor;
  transform-origin: center center;
}
</style>
